import {LogType} from '../definitions/log-type';
export class LogItem {
   constructor(public id: string,
               public message: string,
               public logType: LogType) {
   }
}



// WEBPACK FOOTER //
// ./src/app/models/logging/log-item.ts